export default __webpack_public_path__ + "static/media/IND.5784a4f6.svg";